<template>

  <CardContainer/>

</template>

<script>
import CardContainer from "./CardContainer";

export default {
  name: "C5",
  components: {CardContainer},
};
</script>

<style scoped>
.page-item.active .page-link {
  color: white !important;
  background: var(--primary) !important;
  border: none;
}

.customPagination > li.active > a,
.customPagination > li > a:hover {
  color: white !important;
  background-color: var(--secondary) !important;
}

.active-categories-filter {
  border: none !important;
  background-color: var(--primary) !important;
  color: var(--dark) !important;
}

.categories-filter {
  border: none !important;
  background-color: var(--secondary) !important;
  color: var(--light) !important;
}


.stand-up-animation {
  transform: translateY(0px);
  transition: all 0.3s ease 0s;
}

.stand-up-animation:hover {

  color: #fff;
  transform: translateY(-7px);
  transition: all 0.3s ease 0s;
}

.animation-shadow:hover {
  box-shadow: 10px 10px 10px rgba(180, 210, 198, 0.4);
}

</style>